module.exports = __webpack_public_path__ + "img/antwerp.e726db29.png";